import React from 'react'
import { HtmlContent } from 'utils'

import styles from '../styles/supplier_tricks_component.module.scss'

const MainSlide = ({description, icon, title, subtitle}) => {
  return (
    <div className={styles.supplier_tricks_component__item}>
          <div className={styles.supplier_tricks_component__item_top}>
            <div>
              <img loading="lazy"
                src={icon}
                width='64px'
                height='64px'
                alt=''
              />
            </div>
            <div className={styles.supplier_tricks_component__item_text}>
              <div className={styles.supplier_tricks_component__item_text_title}>
                {title}
              </div>
              <div className={styles.supplier_tricks_component__item_text_description}>
                {subtitle}
              </div>
            </div>
          </div>
          <HtmlContent 
            content={description} 
            className={styles.supplier_tricks_component__item_bottom}
          />
        </div>
  )
}

export default MainSlide